export default class AscentiaService {
  getData(name, args, refresh, timeToLive) {
    if (!refresh) {
      let refVal = null
      if (args && args.id && this.values[name] && this.values[name][args.id]) {
        refVal = this.values[name][args.id].val
      }
      if (this.values[name] && !(args && args.id)) {
        refVal = this.values[name].val
      }

      if (
        (refVal != null && !timeToLive) ||
        (timeToLive &&
          (Date.now() - this.values[name]?.lastRefresh < timeToLive ||
            Date.now() - this.values[name]?.[args.id]?.lastRefresh <
              timeToLive))
      ) {
        return refVal
      }
    }

    const curVar = this.getters[name](args)
    // need to override the catch method here if there's an error
    // nullify the value so it won't get cached
    curVar.catch(error => {
      this.values[name] = null
      return Promise.reject(error)
    })

    let varTosave = { val: curVar, lastRefresh: Date.now() }

    if (args && args.id) {
      this.values[name] = {
        ...this.values[name],
        [args.id]: varTosave,
      }
    } else {
      this.values[name] = varTosave
    }
    return curVar
  }

  deleteData(name, args) {
    let curVar = this.values[name]
    if (!this.values[name]) {
      curVar = {}
    }
    let timestamp = Date.now()
    while (curVar[timestamp]) {
      timestamp++
    }

    if (curVar.length > 50) {
      curVar.shift()
    }

    curVar[timestamp] = this.deletes[name].bind(this)(args)
    return curVar[timestamp]
  }

  saveData(name, args) {
    let curVar = this.values[name]
    if (!this.values[name]) {
      curVar = {}
    }
    let timestamp = Date.now()
    while (curVar[timestamp]) {
      timestamp++
    }

    if (curVar.length > 50) {
      curVar.shift()
    }

    curVar[timestamp] = this.saves[name].bind(this)(args)
    return curVar[timestamp]
  }

  resetData() {
    const keys = Object.keys(this.getters)
    for (const key in keys) {
      this.values[keys[key]] = null
    }
  }
}
